export const data = [
  {
    id: '1',
    'module-title': 'Cycle',
    'score-title': 'Cycle I',
    'module-image': 'cycle.jpg',
    'score-text':
      'Sets the scene and connects the beginning and the end. The idea behind the module is fleeting, wind like whispers that gradually form the drama of space. Imagine the team grouping into the team meeting room not knowing which project, theme or idea they will explore yet or referring to the realisation that a new process has to evolve from the work that has been done. Gradually through the module pitches and rhythmic patterns enter.',
    image: 'cycle-1.jpg',
    audio: 'cycle-1.mp3',
    'duration-format': 0.0007291666666666667,
    'duration-s': '63',
    'duration-text': '1:03',
    'qr-code': 'cycle-1.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '2',
    'module-image': 'exploration.jpg',
    'module-title': 'Exploration',
    'score-title': 'Exploration 1',
    'score-text':
      'This module traces three forms of musical performance – Trills open the section into which at 1:15 short attacks overwhelm the trills which arrive at 1:55 at long held tones. The musicians here form shifting groups that flow between the musical gestures to the graphic specialisation offered by the musical score.',
    image: 'exploration-1.jpg',
    audio: 'exploration-1.mp3',
    'duration-format': 0.0006712962962962962,
    'duration-s': '58',
    'duration-text': '0:58',
    'qr-code': 'exploration-1.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '3',
    'module-title': 'Ideation',
    'score-title': 'Ideation',
    'module-image': 'ideation.jpg',
    'score-text':
      'Explores how ideas are formed, evolved and debated within the group before the team begins to explore. In this module, the circles express solo sections in which an idea is brought up, the lines debate this idea or move it to another possibility. With the square and lines forming challenges and disruptions to the idea being expressed.',
    image: 'ideation.jpg',
    audio: 'ideation.mp3',
    'duration-format': 0.0007060185185185185,
    'duration-s': '61',
    'duration-text': '1:01',
    'qr-code': 'ideation.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '4',
    'module-title': 'Seeking a Common Language',
    'score-title': 'Seeking a Common Language 1',
    'module-image': 'seeking-a-common-language.jpg',
    'score-text':
      'Begins a setting of group working. In this section the musicians seek to bridge the gap – make sure that they are on the same page. A soloist sets down a proposal which is then echoed by another musician. Each colour represents a musician, each block represents a segment which the next musician seeks to emulate and interpret. ',
    image: 'seeking-a-common-language-1.jpg',
    audio: 'seeking-a-common-language-1.mp3',
    'duration-format': 0.0006944444444444445,
    'duration-s': '60',
    'duration-text': '1:00',
    'qr-code': 'seeking-a-common-language-1.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '5',
    'module-title': 'Spark',
    'score-title': 'Spark I',
    'module-image': 'spark.jpg',
    'score-text':
      'Where does an idea come from, does the idea grow from the initial spark as it is interrogated and challenged by the core group? What is the drama of the excitement of the spark? In this module sparks are expressed by light blue lines. At times other instruments join in to form additional blue lines that explore the original spark. While circles denote disruptions, uncertainties that seek to derail the spark. An additional echo space in grey denotes shadow sparks being formulated in the background.',
    image: 'the-spark-1.jpg',
    audio: 'the-spark-1.mp3',
    'duration-format': 0.0006481481481481481,
    'duration-s': '56',
    'duration-text': '0:56',
    'qr-code': 'the-spark-1.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '6',
    'module-title': 'Seeking a Common Language',
    'score-title': 'Seeking a Common Language 2',
    'module-image': 'seeking-a-common-language.jpg',
    'score-text':
      'Begins a setting of group working. In this section the musicians seek to regroup and create a common language. In this case by a drone through which timber and pitch converge. ',
    image: 'seeking-a-common-language-2.jpg',
    audio: 'seeking-a-common-language-2.mp3',
    'duration-format': 0.00037037037037037035,
    'duration-s': '32',
    'duration-text': '0:32',
    'qr-code': 'seeking-a-common-language-2.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '7',
    'module-title': '22 Referees & Pitching',
    'score-title': '22 Referees & Pitching',
    'module-image': '22-referees.jpg',
    'score-text':
      'A section in which an idea is met with constant challenges that attempt to both clarify it or to wear it down as it attempts to persevere. The idea came from the metaphor of an inverted soccer match. Where the group feedback focused not on the potential opportunities in an idea or on how to improve it, rather on why it won’t work. The central line is the idea performed by a soloist, while the boxes and circle represent interferences, challenges and grumblings from the group. ',
    image: '22-referees.jpg',
    audio: '22-referees.mp3',
    'duration-format': 0.001388888888888889,
    'duration-s': '120',
    'duration-text': '2:00',
    'qr-code': '22-referees.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '8',
    'module-title': 'Group Work',
    'score-title': 'Group Work 1',
    'module-image': 'group-work.jpg',
    'score-text':
      'The larger group is divided into smaller groups each exploring subsets of the thematic challenge. The teams are divided into winds and brass one one side and strings on the other with the central line providing dynamic guidance. ',
    image: 'group-work-1.jpg',
    audio: 'group-work-1.mp3',
    'duration-format': 0.0010532407407407407,
    'duration-s': '91',
    'duration-text': '1:31',
    'qr-code': 'group-work-1.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '9',
    'module-image': 'exploration.jpg',
    'module-title': 'Exploration',
    'score-title': 'Exploration 2',
    'score-text': 'The team is lost. Snippets try to ignite the spark.',
    image: 'exploration-2.jpg',
    audio: 'exploration-2.mp3',
    'duration-format': 0.00034722222222222224,
    'duration-s': '30',
    'duration-text': '0:30',
    'qr-code': 'exploration-2.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '10',
    'module-title': 'Brainstorming',
    'score-title': 'Brainstorming',
    'module-image': 'brainstorming.jpg',
    'score-text':
      'An idea is expressed as the impulse for exploration together between the team which fluctuates between individuals responding to the idea to the team breaking into groups exploring the idea.',
    image: 'brainstorming.jpg',
    audio: 'brainstorming.mp3',
    'duration-format': 0.0008217592592592592,
    'duration-s': '71',
    'duration-text': '1:11',
    'qr-code': 'brainstorming.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '11',
    'module-image': 'exploration.jpg',
    'module-title': 'Exploration',
    'score-title': 'Exploration 3',
    'score-text':
      'The entire ensemble converges into trills moving through the circle. Two instruments remain playing the trill while groups of musicians test small ideas.',
    image: 'exploration-3.jpg',
    audio: 'exploration-3.mp3',
    'duration-format': 0.00048611111111111104,
    'duration-s': '42',
    'duration-text': '0:42',
    'qr-code': 'exploration-3.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '12',
    'module-title': 'Spark',
    'score-title': 'Spark II',
    'module-image': 'spark.jpg',
    'score-text':
      'Where does an idea come from, does the idea grow from the initial spark as it is interrogated and challenged by the core group? What is the drama of the excitement of the spark? In this module sparks are expressed by light blue lines. At times other instruments join in to form additional blue lines that explore the original spark. While boxes of squares and triangles denote disruptions, uncertainties that seek to derail the spark. An additional echo space in grey denotes shadow sparks being formulated in the background.',
    image: 'the-spark-2.jpg',
    audio: 'the-spark-2.mp3',
    'duration-format': 0.000775462962962963,
    'duration-s': '67',
    'duration-text': '1:07',
    'qr-code': 'the-spark-2.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '13',
    'module-title': 'Swarm',
    'score-title': 'Swarm',
    'module-image': 'swarm.jpg',
    'score-text':
      'A sudden alignment that shifts the exploration phase to a new dramatic direction. The module begins with the strings trill that rise as a wave on top of which the winds pierce through as a fanfare the idea that has been explored.',
    image: 'swarm.jpg',
    audio: 'swarm.mp3',
    'duration-format': 0.00047453703703703704,
    'duration-s': '41',
    'duration-text': '0:41',
    'qr-code': 'swarm.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '14',
    'module-image': 'exploration.jpg',
    'module-title': 'Exploration',
    'score-title': 'Exploration 4',
    'score-text':
      'The exploration in this module breaks apart the team working and through the disintegration and chaotic moment the musicians form sporadic groups either exploring or disrupting. The centrepiece of the module is its centre in which the musicians converge to argue. Once they release themselves from the circle they divide into pairs leading into a climax that is suddenly cut off in a pizzicato.',
    image: 'exploration-4.jpg',
    audio: 'exploration-4.mp3',
    'duration-format': 0.0006828703703703703,
    'duration-s': '59',
    'duration-text': '0:59',
    'qr-code': 'exploration-4.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '15',
    'module-image': 'exploration.jpg',
    'module-title': 'Exploration',
    'score-title': 'Exploration 5',
    'score-text':
      'The musicians divide into winds and brass and strings again. The top section is rapid fluid movements with interspersing interventions and disagreements from the strings culminating in grumblings within the circle in the bottom corner and a cut off once again. ',
    image: 'exploration-5.jpg',
    audio: 'exploration-5.mp3',
    'duration-format': 0.0006944444444444445,
    'duration-s': '60',
    'duration-text': '1:00',
    'qr-code': 'exploration-5.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '16',
    'module-image': 'exploration.jpg',
    'module-title': 'Exploration',
    'score-title': 'Exploration 6a',
    'score-text':
      'In the top half of the page the musicians converge into one tone, as though snapping out of their disagreements and confusion and begin from the convergence to experiment with colours of sound as though an idea is being formulated. In the bottom half of the page which happens after the top is done a pattern begins, a groove on which attacks begin. But this time the pattern works and the attacks are not negative but constructive – a spark has been reached.',
    image: 'exploration-6a.jpg',
    audio: 'exploration-6a.mp3',
    'duration-format': 0.00125,
    'duration-s': '108',
    'duration-text': '1:48',
    'qr-code': 'exploration-6a.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '17',
    'module-image': 'exploration.jpg',
    'module-title': 'Exploration',
    'score-title': 'Exploration 6b',
    'score-text':
      'The musicians continue to evolve the spark, expanding the beat from quarter note patterns to eighth note patterns and adding more dynamic attacks and fluid tapestries above the beat.',
    image: 'exploration-6b.jpg',
    audio: 'exploration-6b.mp3',
    'duration-format': 0.0008449074074074075,
    'duration-s': '73',
    'duration-text': '1:13',
    'qr-code': 'exploration-6b.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '18',
    'module-title': 'Seeking a Common Language',
    'score-title': 'Seeking a Common Language 3',
    'module-image': 'seeking-a-common-language.jpg',
    'score-text':
      'The patterns come to a climax with the attacks and fluid tapestries rising and falling, but then around 19:00 things begin unravelling. An idea is no longer so clear and this causes the spark to disintegrate and collapse. ',
    image: 'seeking-a-common-language-3.jpg',
    audio: 'seeking-a-common-language-3.mp3',
    'duration-format': 0.0013541666666666667,
    'duration-s': '117',
    'duration-text': '1:57',
    'qr-code': 'seeking-a-common-language-3.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '19',
    'module-title': 'Group Work',
    'score-title': 'Group Work 2',
    'module-image': 'group-work.jpg',
    'score-text':
      'The team takes a break from the innovation process. Regrouping and exploring when to begin again.',
    image: 'group-work-2.jpg',
    audio: 'group-work-2.mp3',
    'duration-format': 0.0005555555555555556,
    'duration-s': '48',
    'duration-text': '0:48',
    'qr-code': 'group-work-2.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '20',
    'module-title': 'Convergence',
    'score-title': 'Convergence',
    'module-image': 'convergence.jpg',
    'score-text':
      'A fleeting moment where an idea that has been fleshed out comes to fruition. A pitch is held as a long tone upon which ripples of gestures and tones are added and then fade away.',
    image: 'convergence.jpg',
    audio: 'convergence.mp3',
    'duration-format': 0.0012384259259259258,
    'duration-s': '107',
    'duration-text': '1:47',
    'qr-code': 'convergence.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
  {
    id: '21',
    'module-title': 'Cycle',
    'score-title': 'Cycle II',
    'module-image': 'cycle.jpg',
    'score-text':
      'After convergence has disintegrated the cycle that began the work begins again. This time though it is in retrograde to the beginning – gradually fading away into the silent performance that began the work. A metaphor that the evolution of exploration and ideas is a perpetual cycle of  development, disruption and change.',
    image: 'cycle-2.jpg',
    audio: 'cycle-2.mp3',
    'duration-format': 0.0007175925925925927,
    'duration-s': '62',
    'duration-text': '1:02',
    'qr-code': 'cycle-2.png',
    url: 'https://www.zeiss.de/corporate/ueber-zeiss/zukunft/new-business-bei-zeiss/zeiss-innovation-hubs/zeiss-innovation-hub-kit.html',
  },
];

export const details = [
  {
    title: 'The Project',
    subtitle: 'The Contour of Stars',
    id: 'The Project',
    description:
      'In what ways can science, business, and art really bring forth something new? What processes and frameworks, what skills are required? Where are the differences and similarities between the disciplines? And what role do luck and chance play?',
    image: 'info-project.jpg',
  },
  {
    title: 'The Concert',
    subtitle: 'Video (22:00)',
    id: 'The Concert',
    description:
      'How is novelty created in science, business, and art? An interdisciplinary salon talk and a concert by Ensemble Modern took on this question. The highlight was the premiere of a new work by the Israeli composer Emmanuel Witzthum, which was created as part of his creative residency at the ZEISS Innovation Hub @ KIT.',
    image: 'info-concert.jpg',
  },
  {
    title: 'The Composer',
    subtitle: 'Emmanuel Witzthum',
    id: 'The Composer',
    description:
      'Emmanuel Witzthum combines work as composer, artistic director and creator of artistic digital experiences. He currently serves as Head of Creative Development for the Jerusalem Season of Culture and as the curator of the creative resident program at the ZEISS Innovation hub at KIT.',
    image: 'info-portrait-emmanuel-witzthum.jpg',
  },
  {
    title: 'The Musicians',
    subtitle: 'Ensemble Modern',
    id: 'The Musicians',
    description:
      'Ensemble Modern is one of the world’s best-known and leading contemporary music performance groups, describing itself as “a curious loudspeaker for music of our times: courageous, uncompromising, energetic”.',
    image: 'info-musicians.jpg',
  },
];
